<template>
	<div v-if="window.size.desktop">
		<div v-click-outside="clickOutside"
         :style="{ top: showSearch ? '' : (biggerGap ? '56px' : '34px') }"
         class="bg-[#283344] w-[calc(100%-15px)] absolute top-0 rounded-zt
					      border border-zt-light shadow-zt xl:w-full xl:max-h-[590px] z-modal">
      <div v-if="showSearch" class="py-[13px] px-2 relative border-b border-zt-light">
        <input type="text" class="w-full h-[38px] bg-[#283344] border-[1px] border-zt-light rounded-zt
                      text-xs text-zt-white pl-[6px] focus:outline-none"
               placeholder="Wyszukaj..."
               v-model="search">
        <svg class="absolute right-5 top-1/2 -translate-y-1/2" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M15.1496 13.8303C15.3316 14.0123 15.3316 14.3075 15.1496 14.49L14.49 15.1496C14.3075 15.3316 14.0123 15.3316 13.8303 15.1496L9.21207 10.5314C9.16192 10.4813 9.12848 10.422 9.10603 10.359C8.15879 11.0511 6.99564 11.4643 5.73217 11.4643C2.56658 11.4643 0 8.89776 0 5.73217C0 2.56658 2.56658 0 5.73217 0C8.89776 0 11.4643 2.56658 11.4643 5.73217C11.4643 6.99564 11.0511 8.15879 10.359 9.10603C10.422 9.12848 10.4813 9.16144 10.5314 9.21207L15.1496 13.8303ZM5.73217 1.91072C3.62178 1.91072 1.91072 3.62178 1.91072 5.73217C1.91072 7.84256 3.62178 9.55362 5.73217 9.55362C7.84256 9.55362 9.55362 7.84256 9.55362 5.73217C9.55362 3.62178 7.84256 1.91072 5.73217 1.91072Z" fill="white"/>
        </svg>
      </div>
      <div class="max-h-[316px] overflow-y-auto">
        <div v-for="(team, index) in filteredTeams" :key="team[teamIdField]"
             @click.prevent="changeSelectedTeam(team)"
             :class="{ '!border-b-0' : index === filteredTeams.length - 1, '!bg-zt-light hover:!bg-zt-light' :  selectedTeam[teamIdField] === team[teamIdField]}"
             class="hover:bg-zt-light/35 bg-[#283344] cursor-pointer pl-[6px] result no-default-style text-[13px]
                      border-zt-light py-2 h-[36px] border-b-[1px] flex items-center gap-x-[6px]">
            <span v-if="team.country_query_name !== null" class="inline-block aspect-square h-5">
              <TeamImg :team="team"/>
            </span>
          <p class="name font-normal truncate" :class="{ '!font-bold' : selectedTeam[teamIdField] === team[teamIdField] }">
            {{ team.shortname?.length > 0 ? team.shortname : team.name }}
          </p>
        </div>
      </div>
		</div>
	</div>
	<div v-else>
		<div :class="{ 'top-[32px]' : WP.user.adminBar }"
			class="bg-[#283344] w-full h-full overflow-y-hidden fixed z-modal top-0 left-0 rounded-zt
					        border border-zt-light shadow-zt xl:w-full xl:max-h-[590px]">
			<div class="flex items-center border-b border-zt-light pl-4 pr-3.5 h-[55px] gap-4 xl:gap-5">
				<span class="text-xl font-medium">Wybierz drużynę</span>
				<div class="x-close-modal"
				     @click.stop="$emit('close')"></div>
			</div>
      <div v-if="showSearch" class="py-[13px] px-2 relative border-b border-zt-light">
        <input type="text" class="w-full h-[40px] bg-[#283344] border-[1px] border-zt-light rounded-zt
                      text-xs text-zt-white pl-[6px] focus:outline-none"
               placeholder="Wyszukaj..."
               v-model="search">
        <svg class="absolute right-5 top-1/2 -translate-y-1/2" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M15.1496 13.8303C15.3316 14.0123 15.3316 14.3075 15.1496 14.49L14.49 15.1496C14.3075 15.3316 14.0123 15.3316 13.8303 15.1496L9.21207 10.5314C9.16192 10.4813 9.12848 10.422 9.10603 10.359C8.15879 11.0511 6.99564 11.4643 5.73217 11.4643C2.56658 11.4643 0 8.89776 0 5.73217C0 2.56658 2.56658 0 5.73217 0C8.89776 0 11.4643 2.56658 11.4643 5.73217C11.4643 6.99564 11.0511 8.15879 10.359 9.10603C10.422 9.12848 10.4813 9.16144 10.5314 9.21207L15.1496 13.8303ZM5.73217 1.91072C3.62178 1.91072 1.91072 3.62178 1.91072 5.73217C1.91072 7.84256 3.62178 9.55362 5.73217 9.55362C7.84256 9.55362 9.55362 7.84256 9.55362 5.73217C9.55362 3.62178 7.84256 1.91072 5.73217 1.91072Z" fill="white"/>
        </svg>
      </div>
			<div class="overflow-y-auto h-[calc(100%-118px)]" :class="[{ '!h-[calc(100%-160px)]' : WP.user.adminBar && showSearch },
			  !showSearch &&  WP.user.adminBar ? '!h-[calc(100%-87px)]' : 'h-[calc(100%-55px)]']">
				<div v-for="(team, index) in filteredTeams" :key="team[teamIdField]"
				     @click.prevent="changeSelectedTeam(team)"
				     :class="{ 'border-b-0' : index === filteredTeams.length - 1, '!bg-zt-light hover:!bg-zt-light' :  selectedTeam[teamIdField] === team[teamIdField]}"
				     class="bg-[#283344] cursor-pointer pl-[6px] result no-default-style text-[13px]
                    border-zt-light py-2 h-[36px] border-b-[1px] flex items-center gap-x-[6px] hover:xl:bg-zt-light/35">
					<span v-if="team.country_query_name !== null" class="inline-block aspect-square h-5">
						<TeamImg :team="team"/>
					</span>
					<p class="name font-normal" :class="{ '!font-bold' : selectedTeam[teamIdField] === team[teamIdField] }">
						{{ team.shortname?.length > 0 ? team.shortname : team.name }}
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import TeamImg from './TeamImg.vue';
import utils_mixin from '../../../mixins/utils_mixin';
import { loadSelectedTeam, saveSelectedTeam } from '../../../../assets/js/utils';

export default {
  name: 'TeamSelectList',
	inject: ['WP'],
  emits: ['init-option', 'selectedTeam', 'close'],
	mixins: [utils_mixin],
  components: { TeamImg },
	props: {
		teamsSelect: {
			type: Array,
		},
		defaultSelectedTeam: {
			type: Object,
		},
    teamIdField: {
      type: String,
      default: 'team_id',
    },
    biggerGap: {
      type: Boolean,
      default: false,
    },
    showSearch: {
      type: Boolean,
      default: false,
    },
    teamSelectOpen: {
      type: Boolean,
      default: false,
    },
    resetSelectedTeam: {
      type: Boolean,
      default: false,
    },
	},
  data() {
    return {
      selectedTeam: this.defaultSelectedTeam,
      clickOutside: {
        handler: () => {
          this.changeSelectedTeam(this.selectedTeam);
        },
        events: ['touchstart', 'mousedown']
      },
      search: ''
    }
  },
  computed: {
    filteredTeams() {
      if (this.search === '') {
        return this.teamsSelect;
      }
      return this.teamsSelect.filter(team => {
        return team.name.toLowerCase().includes(this.search.toLowerCase()) ||
            team.short_name?.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  },
  watch: {
    teamSelectOpen() {
      setTimeout(() => {
        this.search = '';
      }, 300);
    },
    resetSelectedTeam() {
      this.selectedTeam = this.defaultSelectedTeam;
    },
  },
  mounted() {
    this.setSelectedTeam(loadSelectedTeam());
    this.$emit('init-option', this.selectedTeam);
    window.addEventListener('pagehide', () => saveSelectedTeam(this.selectedTeam));
  },
  updated() {
    setTimeout(() => {
      this.markSearchDivFilters();
    }, 0);
  },
  methods: {
    setSelectedTeam(team) {
      if (!team) {
        team = this.defaultSelectedTeam;
      }
      this.selectedTeam = team;
    },
    markSearchDivFilters() {
      const resultsDiv = document.querySelectorAll('.result');
      resultsDiv.forEach(node => {
        const fields = [
          { selector: '.name', property: 'textContent' },
        ];
        fields.forEach(({selector, property}) => {
          const fieldNode = node.querySelector(selector);
          if (!fieldNode) return;

          fieldNode.innerHTML = fieldNode.innerHTML.replace(/(<span class="bg-\[#6FAD6E99]">|<\/span>)/gi, '');

          const regex = this.generatePolishRegex(this.search.toLowerCase());

          fieldNode.innerHTML = fieldNode.innerHTML.replace(regex, (match) =>
              '<span class="bg-[#6FAD6E99]">' + match + '</span>'
          );

        });
      });
    },
		changeSelectedTeam(team) {
      this.setSelectedTeam(team);
      this.$emit('selectedTeam', team);
		},
	}
}
</script>


<style scoped>
.fade-enter-active,
.fade-leave-active {
	z-index: 10;
	transition: all 0.3s ease-out;
}

.fade-enter-from,
.fade-leave-to {
	z-index: 10;
	opacity: 0;
}
</style>